import { render, staticRenderFns } from "./RegisterStepTwo.vue?vue&type=template&id=62deaad2&scoped=true&"
import script from "./RegisterStepTwo.vue?vue&type=script&lang=js&"
export * from "./RegisterStepTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62deaad2",
  null
  
)

export default component.exports